import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      number: '01',
      title: 'Valet Parking',
      subtitle: 'Eventos e Empresas',
      description:
        'Gestão profissional de estacionamento com equipe treinada e processos padronizados. Seguro dos veículos durante toda a operação.',
      icon: 'ri-steering-2-line',
    },
    {
      number: '02',
      title: 'Motorista Executivo',
      subtitle: 'Transporte Corporativo',
      description:
        'Condução corporativa de veículos com profissionais qualificados, pontualidade e total discrição.',
      icon: 'ri-car-line',
    },
    {
      number: '03',
      title: 'Logística',
      subtitle: 'Movimentação de Mobiliário',
      description:
        'Transporte, movimentação e organização de estruturas, móveis e equipamentos para eventos e empresas.',
      icon: 'ri-truck-line',
    },
  ];

  return (
    <section className="bg-light py-32 lg:py-40">
      <div className="w-full px-12 lg:px-20">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <span className="inline-block text-xs font-semibold tracking-[0.2em] text-secondary/60 uppercase mb-4">
              Serviços
            </span>
            <h2 className="text-3xl lg:text-4xl font-medium text-primary leading-tight">
              Soluções<br />
              <span className="text-secondary/40">Integradas</span>
            </h2>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1 }}
            viewport={{ once: true }}
            className="max-w-md"
          >
            <p className="text-secondary text-base leading-relaxed">
              O Grupo Prime oferece soluções completas através da atuação integrada de suas empresas operacionais.
            </p>
          </motion.div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="group bg-white rounded-2xl p-8 lg:p-10 hover:shadow-xl transition-all duration-500 cursor-pointer"
            >
              {/* Icon */}
              <div className="w-14 h-14 rounded-xl bg-primary/5 flex items-center justify-center mb-8 group-hover:bg-primary group-hover:scale-110 transition-all duration-500">
                <i className={`${service.icon} text-2xl text-primary group-hover:text-white transition-colors duration-500`}></i>
              </div>

              {/* Number */}
              <span className="text-xs font-medium text-secondary/40 tracking-wider">
                {service.number}
              </span>

              {/* Title */}
              <h3 className="text-2xl font-semibold text-primary mt-2 mb-1">
                {service.title}
              </h3>
              <p className="text-sm text-secondary/60 mb-6">
                {service.subtitle}
              </p>

              {/* Description */}
              <p className="text-secondary text-sm leading-relaxed mb-8">
                {service.description}
              </p>

              {/* Link */}
              <div className="flex items-center gap-2 text-primary font-medium text-sm group-hover:gap-4 transition-all duration-300">
                <span>Saiba mais</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mt-16"
        >
          <Link
            to="/servicos"
            className="inline-flex items-center gap-3 bg-primary text-white font-medium text-sm px-8 py-4 rounded-full hover:bg-primary/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Ver Todos os Serviços
            <i className="ri-arrow-right-line"></i>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesSection;
